import React from "react";
import { ChatBubbleOutline } from "@mui/icons-material";

interface CommentCountProps {
  count: number;
  onClick?: () => void;
  className?: string;
  showIcon?: boolean;
  showZero?: boolean;
  label?: string;
}

/**
 * A component to display the comment count outside the CommentBox
 * Can be used as a button to show/hide comments
 */
const CommentCount: React.FC<CommentCountProps> = ({
  count,
  onClick,
  className = "",
  showIcon = true,
  showZero = false,
  label = "Comments",
}) => {
  // Don't render anything if count is 0 and showZero is false
  if (count === 0 && !showZero) {
    return null;
  }

  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-1.5 text-neutral-600 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-neutral-100 transition-colors ${className}`}
      aria-label={`${count} ${label}`}
    >
      {showIcon && <ChatBubbleOutline sx={{ width: 18, height: 18 }} />}
      <span className="font-medium">
        {count} {label}
      </span>
    </button>
  );
};

export default CommentCount;
